import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isInTauriShell } from '@renderer/lib/runtime'

declare global {
  interface Window {
    /** Called from Android MainActivity when hardware back is pressed. */
    __dreamboothHistoryBack?: () => void
  }
}

/**
 * Registers a global hook so the Android WebView can invoke React Router `navigate(-1)`
 * from native code (see dreambooth-tauri MainActivity).
 */
export function TauriAndroidBackBridge(): null {
  const navigate = useNavigate()

  useEffect(() => {
    if (!isInTauriShell()) return
    const handler = (): void => {
      navigate(-1)
    }
    window.__dreamboothHistoryBack = handler
    return (): void => {
      delete window.__dreamboothHistoryBack
    }
  }, [navigate])

  return null
}
